import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

export class LocaleInterceptor implements HttpInterceptor {
  constructor(
    private readonly triggerUrls: string[],
    private readonly translateService: TranslateService
  ) {}

  public canHandle(url: string): boolean {
    return (
      this.triggerUrls.findIndex(
        (triggerUrl) => url.startsWith(triggerUrl),
        url
      ) !== -1
    );
  }

  public intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const url = req.url.toLowerCase();

    if (this.canHandle(url) && this.translateService.currentLang) {
      req = req.clone({
        headers: req.headers.set(
          'Accept-Language',
          this.translateService.currentLang
        ),
      });
    }

    return next.handle(req);
  }
}
